import SpeakToAdvisorPageContainer from './SpeakToAdvisorPageContainer';

export default SpeakToAdvisorPageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/SpeakToAdvisorPage/index.js